export default defineNuxtRouteMiddleware((to) => {
  // Устанавливаем заголовки кэширования для статических ресурсов
  if (process.server) {
    const event = useRequestEvent()
    
    // Проверяем, является ли запрос статическим ресурсом
    const staticPaths = [
      '/images/',
      '/fonts/',
      '/video/',
      '/frames/',
      '/partners/',
      '/integrations/',
      '/codeLangs/',
      '/flags/',
      '/sx/',
      '/blog/',
      '/mailing/',
      '/_nuxt/'
    ]
    
    const isStaticResource = staticPaths.some(path => to.path.startsWith(path))
    
    if (isStaticResource) {
      // Устанавливаем заголовки кэширования
      event.node.res.setHeader('Cache-Control', 'public, max-age=31536000, immutable')
      event.node.res.setHeader('Expires', new Date(Date.now() + 31536000000).toUTCString())
      
      // Для изображений добавляем дополнительные заголовки
      if (to.path.match(/\.(jpg|jpeg|png|gif|webp|avif|svg)$/i)) {
        event.node.res.setHeader('Content-Type', 'image/' + to.path.split('.').pop())
      }
      
      // Для шрифтов
      if (to.path.match(/\.(woff|woff2|ttf|otf)$/i)) {
        event.node.res.setHeader('Content-Type', 'font/' + to.path.split('.').pop())
        event.node.res.setHeader('Access-Control-Allow-Origin', '*')
      }
    }
  }
})
